import styled from 'styled-components'

export const Row = styled.div`
  display: flex;
`

export const BoxImage = styled.div`
  padding-right: 20px;
  flex-shrink: 0;
  height: 144px; 
  width: 122px;
`

export const Image = styled.img`
  max-width: 100%;
  height: auto;
`

export const Buttons = styled.div`
  flex: 0 0 auto;
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: flex-end;

  .btn-close {
    margin-left: 8px;
  }

  @media (max-width: 350px) {
    .btn-close {
      height: 60px;
    } 
  }
`
